import { render, staticRenderFns } from "./AnalysisPresets.vue?vue&type=template&id=37a18490&"
import script from "./AnalysisPresets.vue?vue&type=script&lang=js&"
export * from "./AnalysisPresets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports